import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

import router from '@/routes'
import hooks from '@/routes/hooks' // 路由钩子
import store from '@/store'

import * as filters from './filters' // 全局filter

import '@/styles/index.scss' // global css
import 'tailwindcss/base.css';
import 'tailwindcss/components.css';
import 'tailwindcss/utilities.css';

import axios from 'axios'
Vue.prototype.$http = axios;

Vue.use(ElementUI);
Object.keys(filters).forEach(key => {
    Vue.filter(key, filters[key])
})


Vue.directive('preventReClick', {
    inserted (el, binding) {
        el.addEventListener('click', () => {
            el.classList.add('event-disabled')
            el.disabled = true
            setTimeout(() => {
                el.disabled = false
                el.classList.remove('event-disabled');
            }, binding.value || 3000)
        })
    }
})

hooks(router, store) // 路由钩子事件

require('es6-promise').polyfill() // Promise 支持适配

Vue.config.productionTip = false
new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
